<template>
  <nuttrema-layout-cred>
    <template slot="content">

      <nuttrema-loader v-if="ProgramDetails.fetching"></nuttrema-loader>

      <nuttrema-empty-result v-else-if="ProgramDetails.error" icon="fa fa-rocket">
        <template slot="text">
          <h1 v-html="$t('label.error_loading_text')"></h1>
          <h4 v-html="$t('label.error_loading_error_text')"></h4>
        </template>
      </nuttrema-empty-result>

      <nuttrema-empty-result  v-else-if="ProgramDetails.notFound" icon="fal fa-exclamation-triangle">
        <template slot="text">
          <h1 v-html="$t('label.item_not_found')"></h1>
          <h4 v-html="$t('label.item_not_found_text')"></h4>
        </template>
      </nuttrema-empty-result>

      <router-view v-else></router-view>

    </template>
  </nuttrema-layout-cred>
</template>

<script>
import PageProps from 'components/mixins/page-props';

import NuttremaLayoutCred from 'components/ui/layout/nuttrema-layout-cred';

export default {
  name: 'page-diet-main-information',
  componentName: 'PageDietMainInformation',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaLayoutCred,
  },
  computed: {
    ProgramDetails() {
      return this.$store.getters.ProgramDetails(this.id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/diets/details/main-information/page-diet-main-information.vue